export const storageKeys = {
    auth_token: "auth_token",
    userDetails: "user_details",
    user_id: "user_id"
}